export const createArrayOfAttachments = (attachments) => {
  return attachments.map((file) => {
    const formData = new FormData();
    formData.append('File', file, file.name);
    formData.append('Name', file.name);
    return formData;
  });
};
